import Image from 'next/image';
import Link from 'next/link';
import { useRouter } from 'next/router';
import React, { useState } from 'react';
import { removeDefaultParams } from '../../../Utils/helper';
import { clickCardEvent } from '../../../Utils/StoreHomePageUtils';
import { BrowseCatStyled } from '../BrowseCategoryHome/styled';
import { CategoryCard, CategoryProdImage, CategoryProdName } from './styled';

export default function CategoryProducts(props) {
  const { cardItems, type, data } = props;
  const router = useRouter();
  const [focusElement, setFocusElement] = useState(null);
  const categoryClickHandler = (value) => {
    // navigateToCategory(value?.deeplinkValue);
    clickCardEvent(value, value?._id, type, value?.name, data);
  };
  return (
    <BrowseCatStyled filterStoreCard>
      {cardItems?.map((data) => {
        return data?.items?.map((element, index) => {
          return (
            <Link
              href={{
                pathname: element?.deeplinkValue,
                query: removeDefaultParams(router.query),
              }}
              passHref
              key={index}
              locale={false}
              legacyBehavior
            >
              <CategoryCard
                className={focusElement == index ? 'lowOpacity' : ''}
                onClick={() => {
                  setFocusElement(index);
                }}
                key={`prod${index}`}
                as="a"
              >
                {/* <CategoryProdImage
                                    src={element?.icon}
                                    srcSet={`${element?.icon}?tr=w-120,q-60 2w, ${element?.icon}?tr=w-450,q-60 450w`}
                                    sizes="(max-width: 720px) 2px,450px"
                                    alt="categoryImage"
                                    onClick={() =>
                                        categoryClickHandler(element)
                                    }
                                /> */}
                <CategoryProdImage>
                  <Image
                    src={
                      element?.mobileWebIcon
                        ? element?.mobileWebIcon
                        : element?.icon
                    }
                    alt={element?.name}
                    className="image"
                    quality={90}
                    onClick={() => categoryClickHandler(element)}
                    fill
                    sizes="15vw"
                  />
                </CategoryProdImage>

                <CategoryProdName>{element?.name}</CategoryProdName>
              </CategoryCard>
            </Link>
          );
        });
      })}
    </BrowseCatStyled>
  );
}
